import { IconDownload } from '@tabler/icons-react';
import React from 'react';
import {
  BasicActionIcon,
  IBasicActionIconProps,
} from 'src/design/atoms/BasicActionIcon';

export type IDownloadActionIconProps = Omit<
  IBasicActionIconProps,
  'children'
> & {
  iconSize?: number;
};

const DefaultProps: Partial<IDownloadActionIconProps> = {
  color: 'blue',
};

/** @registry Blue "download" action icon built on BasicActionIcon. */
export const DownloadActionIcon = React.forwardRef<
  HTMLButtonElement,
  IDownloadActionIconProps
>(({ iconSize = 20, ...props }, ref) => {
  return (
    <BasicActionIcon {...DefaultProps} {...props} ref={ref}>
      <IconDownload size={iconSize} />
    </BasicActionIcon>
  );
});
DownloadActionIcon.displayName = 'DownloadActionIcon';
